import {
  FETCH_SUBSCRIPTION_PLANS,
  RECEIVE_SUBSCRIPTION_PLANS,
  SUBSCRIPTION_PLANS_ERROR,
} from "../../actions/SubscriptionPlans";

const initialState = {
  status: "loading",
  plans: [],
};

const SubscriptionPlans = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SUBSCRIPTION_PLANS: {
      return Object.assign({}, state, { status: "loading" });
    }
    case RECEIVE_SUBSCRIPTION_PLANS: {
      return { status: "success", plans: action.plans };
    }
    case SUBSCRIPTION_PLANS_ERROR: {
      return Object.assign({}, state, {
        status: "error",
        error: action.error,
      });
    }
    default: {
      return state;
    }
  }
};

export default SubscriptionPlans;
